import "./noticeList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import NoticeTable from "../noticetable/NoticeTable";

const NoticeList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <NoticeTable />
      </div>
    </div>
  );
};

export default NoticeList;
